import { z } from 'zod';

export const authUserResponseSchema = z.object({
  email: z.string(),
  username: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
});

export type AuthUserResponse = z.infer<typeof authUserResponseSchema>;

export const updateProfileRequestSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
});

export type UpdateProfileRequest = z.infer<typeof updateProfileRequestSchema>;

export const changePasswordRequestSchema = z.object({
  oldPassword: z.string(),
  newPassword: z.string(),
});

export type ChangePasswordRequest = z.infer<typeof changePasswordRequestSchema>;

export const loginRequestSchema = z.object({
  email: z.email(),
  password: z.string(),
});

export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const loginResponseSchema = z.object({
  accessToken: z.string(),
});

export type LoginResponse = z.infer<typeof loginResponseSchema>;

export const refreshResponseSchema = z.object({
  accessToken: z.string(),
});

export type RefreshResponse = z.infer<typeof refreshResponseSchema>;

export const signUpRequestSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().email(),
  password: z.string().min(1),
  language: z.enum(['cs', 'en']),
});

export type SignUpRequest = z.infer<typeof signUpRequestSchema>;

export const acceptInvitationRequestSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  password: z.string().min(1),
});

export type AcceptInvitationRequest = z.infer<typeof acceptInvitationRequestSchema>;

export const countrySchema = z.object({
  code: z.string(),
  name: z.string(),
});
export type Country = z.infer<typeof countrySchema>;
